
















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Bar } from 'vue-chartjs/legacy';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ChartDataLabels, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

@Component({
  components: { Bar },
})
export default class ColumnChart extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Number, required: false, default: 400 }) height!: number;
  @Prop({ type: Array, required: true }) categories!: string[];
  @Prop({ type: String, required: false }) dataLabel!: string;
  @Prop({ type: Array, required: true }) datasetData!: number[];
  get chartData() {
    return {
      labels: this.categories,
      datasets: [
        {
          label: this.dataLabel,
          backgroundColor: '#28C76F',
          data: this.datasetData,
        },
      ],
    };
  }

  chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          display: false,
        },
      },
      x: {
        beginAtZero: true,
        ticks: {
          callback: function (value: number) {
            return value >= 1000 ? value / 1000 + 'k' : value;
          },
        },
      },
    },
    plugins: {
      datalabels: {
        display: true,
        color: '#fff',
        anchor: 'center',
        offset: 8,
        formatter: (value: number) => value.toLocaleString('de-DE'),
      },
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(0,0,0,0.85)',
        boxPadding: 5,
        padding: 8,
      },
    },
  };
}
